///////////////////
// Auto-generated
// Do not edit!!!
///////////////////
export class DpTransparentRacuni {
    public SifKor: number;
    public IDPrometa: string;
    public DatDk: Date;
    public BrojUFA: string;
    public SifPar: number;
    public NazPar: string;
    public OIB: string;
    public PDVID: string;
    public OpisDk: string;
    public OpisKonto: string;
    public Iznos: number;
    public EvidBroj: string;
    public Valuta: Date;
    public Klasa: string;
    public UrBroj: string;
    public ProKor: string;
}



// WEBPACK FOOTER //
// C:/Users/vjug.INFODESIGN/OtvoreniGrad2/app/src/app/data/dp-transparent/racuni.model.ts